// extracted by mini-css-extract-plugin
export default {"video":"VideoPopup_video__F3xN6"};